<template>
    <div @click="chooseFile()" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive"
        @drop.prevent="onDrop"
        class="w-full h-44 flex flex-col cursor-pointer items-center justify-center border border-dashed border-gray-300 bg-white p-6"
        :class="{ 'border-2 border-black': active }">
        <div class="flex items-center justify-between flex-col pb-8 relative">
            <UploadIcon class="text-success mb-6" size="48" />
            <span :class="{ 'text-success-tier': active }">{{ dataLocale.data.title }}</span>
            <span class="absolute bottom-0 text-sm" v-if="scanner.scanning">
                <IconsLoadingDecorator class="w-6 h-6" /> {{ $t('scanning') }} ...
            </span>
        </div>
        <input type="file" class="hidden" accept="image/*" ref="file_image" multiple @change="onUploadFile">
    </div>
</template>
<script lang="ts" setup>
import { UploadIcon } from "vue-tabler-icons";
import { } from "@headlessui/vue";
import { processFile } from "~/config/misc/scanner";
import { useScanner } from "~~/stores/scanner";
import DataLocale from "~~/config/interface/DataLocale";

const dataLocale = new DataLocale([
    {
        locale: "en",
        title: "Upload or drag and drop images"
    },
    {
        locale: "vi",
        title: "Tải lên hoặc kéo và thả hình ảnh"
    },
    {
        locale: "fr",
        title: "Télécharger ou glisser-déposer des images"
    },
    {
        locale: "it",
        title: "Carica o trascina e rilascia immagini"
    },
    {
        locale: "es",
        title: "Subir o arrastrar y soltar imágenes"
    },
    {
        locale: "pt",
        title: "Carregar ou arrastar e soltar imagens"
    },
    {
        locale: "de",
        title: "Bilder hochladen oder per Drag & Drop hinzufügen"
    },
    {
        locale: "ja",
        title: "画像をアップロードまたはドラッグアンドドロップ"
    },
    {
        locale: "nl",
        title: "Afbeeldingen uploaden of slepen en neerzetten"
    },
    {
        locale: "zh",
        title: "上传或拖放图像"
    }
])
interface ResponseScanner {
    content: string;
    name?: string;
    file?: string;
    type?: string
}
const utils = useUtils()
const scanner = useScanner()
const file_image = ref<HTMLInputElement>()

const chooseFile = () => {
    file_image.value?.click()
}
const onUploadFile = (e: Event) => {
    const files = [...(e.target as HTMLInputElement).files ?? []]
    if (files.length) {
        runDecoder(files)
    }
    (file_image.value as HTMLInputElement).value = '';
}
// data transfer
const onDrop = (e: DragEvent) => {
    setInactive()
    const files = [...e.dataTransfer?.files ?? []];
    if (files.length) {
        runDecoder(files)
    }
}

const runDecoder = (files: Array<File>) => {
    scanner.startScanning()
    const resultPromises = files.map(processFile);

    Promise.all(resultPromises).then((values) => {
        var data: Array<ResponseScanner> = []
        values.forEach(async (item, index) => {
            const { content } = item
            if (content) {
                data.push({
                    content,
                    file: '',
                    name: files[index].name
                })
            }

        })
        scanner.response = data;
        scanner.openModal()
        scanner.scanning = false
    }).catch(err => {
        scanner.scanning = false
        console.log(err);
    });
}

const active = ref(false)
var inActiveTimeout: any = null

function setActive() {
    active.value = true
    clearTimeout(inActiveTimeout)
}
function setInactive() {
    inActiveTimeout = setTimeout(() => {
        active.value = false
    }, 50)
}

// add event
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
function preventDefaults(e: Event) {
    e.preventDefault()
}
onMounted(() => {
    events.forEach((eventName) => {
        document.body.addEventListener(eventName, preventDefaults)
    })
})
onUnmounted(() => {
    events.forEach((eventName) => {
        document.body.removeEventListener(eventName, preventDefaults)
    })
})
</script>